import React, { Component } from "react";
import Register from "../../../components/Register/Register";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : RegisterForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se llama al componente Resgister
================================================================================ */

class RegisterForm extends Component{
    render(){
        return(
            <Register/>  
        )   
    }
}

export default RegisterForm;